import { MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export const WhatsAppFloat = () => {
  const { content } = useSite();
  const number = (content?.whatsapp || "919000000000").replace(/[^0-9]/g, "");
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={`https://wa.me/${number}?text=${encodeURIComponent("Hello SSS GROUPS, I would like to enquire about your services.")}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with SSS GROUPS on WhatsApp"
      className="animate-float-slow fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/30 transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
};
